<template>
  <div class="success-step-container">
    <span class="success-step-container__icon" />
    <p class="success-step-container__criteria-send">
      {{ trans('guided_search.success.criteria_send') }}
    </p>
    <p class="success-step-container__text">
      {{ trans('guided_search.success.send') }}
    </p>
    <p class="separator success-step-container__separator">
      <span />
    </p>
    <p v-if="store.offersCount" class="success-step-container__offers">
      {{ trans('guided_search.success.offers', { count: store.offersCount }) }}
    </p>
    <p v-else class="success-step-container__offers">
      {{ trans('guided_search.success.zero_offers') }}
    </p>
    <div class="success-step-container__btn">
      <a class="btn btn--primary btn--with-icon" :href="store.customSearchUrl">
        {{ trans('guided_search.success.browse') }}
        <span />
      </a>
    </div>
    <div class="success-step-container__link__link">
      <a class="link" :href="$home_url">
        {{ trans('guided_search.success_small.return') }}
      </a>
    </div>
  </div>
</template>

<script>
import { translationMixin } from '@elements/translation';
import { guidedSearchMixin } from '@organisms/guided-search/guidedSearchMixin';

export default {
  mixins: [ translationMixin, guidedSearchMixin ],
};
</script>
